import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/form-download');
}
//Get all active
export function allActive(){
    return http().get('/form-download/active');
}
//Get Single
export function single(id){
    return http().get(`/form-download/${id}`);
}
//Add one
export function add(data){
    return httpFile().post('/form-download', data)
}
//Update
export function update(id, data){
    return httpFile().post(`/form-download/${id}`, data)
}
//fileDownload
export function fileDownload(id){
    return http().get(`/form-download/fileDownload/${id}`)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/form-download/${id}`);
}